import { Container } from "./style";

import { Layout } from "../../components/Layout";
import { Button } from "../../components/Button";

import GooglePlay from "../../assets/img/google-play.png";
import PlayStore from "../../assets/img/play-store.png";
import QrCode from "../../assets/img/qr-code.png";

import { useSchedulle } from "../../contexts/Schedulle";

import {
  CheckCircle,
  Warning,
  DeviceMobileCamera,
  VideoCamera,
  Alarm,
} from "phosphor-react";

import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/Auth";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next'

import { Modal } from "../../components/Modal";
import LanguageSelector from "../../components/LanguageSelector";

export const Confirmation = () => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const navigate = useNavigate();
  const { language } = useParams();
  const { schedulle, response } = useSchedulle();
  const [modalOpen, setModalOpen] = useState(false);
  const [dataAgendada] = useState(new Date(schedulle?.selected_time));

  const daysOfWeek = [
    t('utils.weekDaysAbbr.sunday'),
    t('utils.weekDaysAbbr.monday'),
    t('utils.weekDaysAbbr.tuesday'),
    t('utils.weekDaysAbbr.wednesday'),
    t('utils.weekDaysAbbr.thursday'),
    t('utils.weekDaysAbbr.friday'),
    t('utils.weekDaysAbbr.saturday')
  ];

  const hadleRemarcacao = () => {
    setModalOpen(!modalOpen);
  };

  const handleApp = () => {
    window.open(
      "https://smartfitapp.page.link/4cqW",
      "_blank"
    );
  };

  useEffect(() => {
    if (token?.token === undefined) {
      navigate(`/${language}`);
    }
  }, []);

  return (
    <>
      <Layout>
        <Container>
          <div className="topBar"></div>
          <div className="confirmation">
            <h1>
              <span>
                <i>
                  <CheckCircle />
                </i>
              </span>
              {t('confirmationPage.title')}
            </h1>
            <div className="confirmation-information">
              <div className="confirmation-information-datetime">
                <p>{`${
                  daysOfWeek[dataAgendada?.getDay()]
                }, ${dataAgendada?.getDate()}/${dataAgendada?.getMonth() + 1} ${t('confirmationPage.datePreposition')} ${
                  schedulle?.time_formated
                }`}</p>
              </div>
              <div className="confirmation-information-teacher">
                <div className="confirmation-information-teacher-image">
                  <figure>
                    <img src={response?.coach?.picture_preview} alt="" />
                  </figure>
                  <p>
                    {t('confirmationPage.coach')} 
                    {' '}
                    <span>{response?.coach?.name}</span>
                  </p>
                </div>
                <Button bg={true} label={t('confirmationPage.reschedule').toUpperCase()} evt={hadleRemarcacao} />
              </div>
            </div>
            <div className="confirmation-alerts">
              <h2>
                <span>
                  <i>
                    <Warning />
                  </i>
                </span>
                {t('confirmationPage.important').toUpperCase()}
              </h2>

              <ul>
                <li>
                  <i>
                    <DeviceMobileCamera />
                  </i>
                  <p>
                  {t('confirmationPage.downloadInfo')}
                  </p>
                </li>
                <li className="confirmation-alerts-button-apps">
                  <Button label={t('confirmationPage.downloadAction')} evt={handleApp} />
                </li>
                <li className="confirmation-alerts-get-apps">
                  <div className="confirmation-alerts-apps">
                    <div className="confirmation-alerts-apps-qr">
                      <figure>
                        <img src={QrCode} alt="qr code" />
                      </figure>
                    </div>
                    <div className="confirmation-alerts-apps-lojas">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.eokoe.smartfitcoach"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <figure>
                          <img src={GooglePlay} alt="google play store" />
                        </figure>
                      </a>
                      <a
                        href="https://apps.apple.com/br/app/smart-fit-app/id1308265270"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <figure>
                          <img src={PlayStore} alt="App Store" />
                        </figure>
                      </a>
                    </div>
                  </div>
                </li>
                <li>
                  <i>
                    <VideoCamera />
                  </i>
                  <p>
                    {t('confirmationPage.callInfo')}
                  </p>
                </li>
                <li>
                  <i>
                    <Alarm />
                  </i>
                  <div className="confirmation-alerts-texts">
                    <p>
                      {t('confirmationPage.confirmationInfo')}{" "}
                      <span>{t('confirmationPage.confirmationInfoBold')}</span>.
                    </p>
                    <p>
                      {t('confirmationPage.confirmationInfoTwo')}
                    </p>
                  </div>
                </li>
                <li className="confirmation-alerts-button-site">
                  <a
                    href="https://www.smartfit.com.br/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button label={t('confirmationPage.action')} />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <LanguageSelector />
        </Container>
        {modalOpen && (
          <Modal modalOpen={modalOpen} setModalOpen={setModalOpen} />
        )}
      </Layout>
    </>
  );
};
